// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bar-sub-title[data-v-18da3d39]{font-size:15px;background:#fafafa;padding:10px 5px;margin:10px 0}", ""]);
// Exports
module.exports = exports;
